module.exports = "<div style=\"border: 1px solid red\">detail-faq Component</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/faq-components/detail-faq/detail-faq.component.html
// module id = ./src/app/faq-components/detail-faq/detail-faq.component.html
// module chunks = main